export default __webpack_public_path__ + "static/media/Aafat_Waapas__Naezy__Official_Music_Video.fde84519.mp3";